import { withStyles } from '@mui/styles';
import PageBase from './PageBase';
import styles from './styles';

const Styled = withStyles(styles)(PageBase);

export default Styled;
